import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { fetchSuggestions } from 'actions'
import { suggestionsSelector } from 'selectors'

import SuggestionList from './SuggestionList'
import withValue from './withValue'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

const withSuggestions = (WrappedInput, suggestionType, count) => {
  const mapStateToProps = (state, { value, exclusions }) => ({
    suggestions:
      suggestionsSelector(state, {
        suggestionType,
        value,
        exclusions,
        count,
      }) || [],
  })

  const mapDispatchToProps = dispatch => ({
    fetchSuggestions: value =>
      dispatch(fetchSuggestions(suggestionType, value)),
  })

  return withValue(
    connect(mapStateToProps, mapDispatchToProps)(
      class WithSuggestions extends React.Component {
        state = {
          activeIndex: undefined,
          hoverIndex: undefined,
          focus: false,
        }

        componentDidMount = () => this.props.fetchSuggestions(this.props.value)

        onInputEnter = () => {
          if (this.state.activeIndex !== undefined) {
            this.props.select(this.props.suggestions[this.state.activeIndex])
          } else {
            this.props.select(this.props.value)
          }
          this.setState({
            activeIndex: undefined,
            hoverIndex: undefined,
          })
        }

        onChange = e => {
          this.props.onChange(e)
          const value = e.target.value
          clearTimeout(this.timeout)
          this.timeout = setTimeout(
            () => this.props.fetchSuggestions(value),
            100
          )
          this.setState({
            activeIndex: undefined,
            hoverIndex: undefined,
          })
        }

        incrementActiveSuggestion = () => {
          if (this.state.hoverIndex !== undefined) {
            this.setState(state => ({
              hoverIndex: undefined,
              activeIndex:
                (state.hoverIndex + 1) % this.props.suggestions.length,
            }))
          } else if (this.state.activeIndex !== undefined) {
            this.setState(state => ({
              activeIndex:
                (state.activeIndex + 1) % this.props.suggestions.length,
            }))
          } else {
            this.setState({ activeIndex: 0 })
          }
        }

        decrementActiveSuggestion = () => {
          if (this.state.hoverIndex !== undefined) {
            this.setState(state => ({
              hoverIndex: undefined,
              activeIndex:
                (state.hoverIndex - 1 + this.props.suggestions.length) %
                this.props.suggestions.length,
            }))
          } else if (this.state.activeIndex !== undefined) {
            this.setState(state => ({
              activeIndex:
                (state.activeIndex - 1 + this.props.suggestions.length) %
                this.props.suggestions.length,
            }))
          } else {
            this.setState({ activeIndex: this.props.suggestions.length - 1 })
          }
        }

        setHoverIndex = hoverIndex =>
          this.setState({
            hoverIndex,
            activeIndex: undefined,
          })

        unsetHoverIndex = () => this.setState({ hoverIndex: undefined })

        onFocus = () => this.setState({ focus: true })

        onBlur = () =>
          this.setState({
            focus: false,
            activeIndex: undefined,
            hoverIndex: undefined,
          })

        render() {
          return (
            <Wrapper>
              <WrappedInput
                {...this.props}
                innerRef={el => (this.el = el)}
                onChange={e => this.onChange(e)}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onKeyDown={e => {
                  if (e.key === 'Escape') {
                    this.el.blur()
                  } else if (e.key === 'Enter') {
                    e.preventDefault()
                    this.onInputEnter()
                  } else if (e.key === 'ArrowDown') {
                    e.preventDefault()
                    this.incrementActiveSuggestion()
                  } else if (e.key === 'ArrowUp') {
                    e.preventDefault()
                    this.decrementActiveSuggestion()
                  }
                }}
              />
              {this.state.focus && (
                <SuggestionList
                  suggestions={this.props.suggestions}
                  activeIndex={
                    this.state.activeIndex !== undefined
                      ? this.state.activeIndex
                      : this.state.hoverIndex
                  }
                  setHoverIndex={this.setHoverIndex}
                  unsetHoverIndex={this.unsetHoverIndex}
                  selectSuggestion={this.props.select}
                />
              )}
            </Wrapper>
          )
        }
      }
    )
  )
}

export default withSuggestions



// WEBPACK FOOTER //
// ./src/components/withSuggestions/index.js